<template>
  <store-provider
    v-bind="$options.storeInfo"
    :params="params"
    is-paged
  >
    <template v-slot="{ state: links }">
      <mds-row>
        <mds-col :push="10">
          <h4 class="visited_link_tab__totalelements">
            Total Elements: {{ links('totalElements') }}
          </h4>
        </mds-col>
      </mds-row>
      <mds-table
        row-hover
        show-sortable
      >
        <mds-thead>
          <mds-th
            v-for="header in $options.headers"
            :key="header.fieldName"
            :style="header.style"
            :sortable="header.sortable"
            :sorted="isSorted(header.fieldName)"
            @mds-th-sort-changed="handleSortEvent(header.fieldName, $event)"
          >
            {{ header.text }}
          </mds-th>
        </mds-thead>
        <mds-tbody>
          <mds-tr
            v-for="link in links('job')"
            :key="link.id"
          >
            <mds-td
              v-for="header in $options.headers"
              :key="header.fieldName"
              :style="header.style"
            >
              <template v-if="header.fieldName === 'link'">
                <a
                  :href="link.link"
                  target="_blank"
                >
                  {{ link.link | decodeLink }}
                </a>
              </template>
              <template v-else-if="header.fieldName === 'active'">
                <mds-switch
                  label="Active"
                  hidden-label
                  :checked="link.enabledNextExecution"
                  @change="setNextExecution(link)"
                />
              </template>
              <template v-else-if="header.fieldName === 'lastIndexedDate'">
                {{ link[header.fieldName] | formatDate }}
              </template>
              <template v-else>
                {{ link[header.fieldName] || "—" }}
              </template>
            </mds-td>
          </mds-tr>
        </mds-tbody>
      </mds-table>
    </template>
  </store-provider>
</template>

<script>
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd
} from '@mds/data-table';
import MdsSwitch from '@mds/switch';
import StoreProvider from '@/components/common/StoreProvider';
import { formatDate } from '@/utils/global.util';
import { parseSorted, parseSortParams } from '@/utils/sort.util';
import { patchVisitedLink } from '@/services/api/job.service';
import { VISITED_LINKS_HEADERS } from '@/constants/jobs.constant';
import { MODULE, COMMON } from '@/constants/store.constant';

export default {
  name: 'VisitedLinksTab',
  components: {
    MdsTable,
    MdsSwitch,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    StoreProvider,
  },
  filters: {
    formatDate,
    decodeLink (url) {
      return decodeURI(url);
    },
  },
  props: {
    linkType: {
      type: String,
      required: true,
    },
  },
  computed: {
    params () {
      return { ...this.$route.params, type: this.linkType };
    },
  },
  methods: {
    async setNextExecution (link) {
      await patchVisitedLink(this.$route.params, {
        link: link.link,
        enabledNextExecution: !link.enabledNextExecution,
      });
    },
    async handleSortEvent (fieldName) {
      const value = parseSortParams(this.$store.state[MODULE.JOB], fieldName);
      this.$store.commit(`${MODULE.JOB}/${COMMON.UPDATE_PARAM}`, {
        name: 'sort',
        value,
      });
      await this.$store.dispatch(`${MODULE.JOB}/${COMMON.FETCH_DATA}`, {
        params: this.params,
        shouldReset: true,
      });
    },
    isSorted (fieldName) {
      return parseSorted(this.$store.state[MODULE.JOB], fieldName);
    },
  },
  headers: VISITED_LINKS_HEADERS,
  storeInfo: {
    module: MODULE.JOB,
    action: COMMON.FETCH_DATA,
    getter: COMMON.GET_STATE,
  },
};
</script>

<style lang="scss" scoped>
@import '@mds/typography';

.visited_link_tab {
  &__totalelements {
    @include mds-eyebrow-heading();
  }
}
</style>
